import { session } from 'auth/session'
import { StringParam, useQueryParams, withDefault } from 'use-query-params'

export const useAuthUrlQuery = () => {
  /**
   * If you are logged in, but not yet setup, show the username selection.
   * Otherwise, default to login
   */
  const initialView = session.isLoggedIn() && !session.isAccountSetup() ? 'username' : 'signIn'

  /**
   * Query parameters
   */
  const [query, setQuery] = useQueryParams({
    /**
     * Possible views:
     *  "signIn" | "register" | "username" | "password"
     */
    view: withDefault(StringParam, initialView),
    /**
     * This query is used to show the claim subscription flow,
     * next step after sign-in/sign-up is to claim subscription to an org
     */
    subscriptionId: StringParam,

    /**
     * This query parameter is the Auth0 callback flow 'code'.
     * If provided, this is the callback flow from Auth0.
     */
    code: StringParam,

    /**
     * The type of 'client' that is logging in (e.g. 'browser', 'cli')
     */
    client: withDefault(StringParam, 'browser'),

    /**
     * Error coming back from auth0 if 3rd party cookies are disabled
     */
    error_description: StringParam,

    /**
     * This is for non-browser clients trying to log in (e.g cli or electron app)
     */
    transactionId: StringParam,

    /**
     * This is for the referring app template (e.g. express, website)
     */
    template: StringParam,

    /**
     * When creating an app, this parameter specifies which template or component
     * should be selected. We'll use it to display something fun on the login page.
     */
    package: StringParam,

    /**
     * (Optional)
     * Can be either 'github' or 'google-oauth2'. If specified, then the social
     * auth button is immediately invoked.
     */
    socialAuthType: StringParam,

    /**
     * UTM tracking parameters
     */
    utm_source: StringParam,
    utm_medium: StringParam,
    utm_campaign: StringParam,
    utm_content: StringParam,
    utm_term: StringParam,
  })
  return {
    query,
    setQuery,
  }
}
